import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export const GetStockHistory = async (params: {
  page: number;
  limit: number;
  search?: string;
  action_type?: string | null;
  product_id?: number | string | null;
  type?: "all" | "product" | "raw_material" | string | null;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/stock-history`, { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load stock history.",
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};
